import { getRouteObjectList, withLayout } from '../router/util/router.helper'
import { RouteObjectList } from '../router/model/Route'
import { RouterLayout } from '../router/component/layout/RouterLayout'
import { projectBuilderIds } from '../router/model/RouteId'

export const projectBuilderRoutes: RouteObjectList = [
  withLayout({
    layout: <RouterLayout />,
    routes: getRouteObjectList(projectBuilderIds),
  }),
]